import type { FieldPath, FieldValues } from "react-hook-form";
import { CdcSelectField, type CdcSelectFieldProps } from "./cdc-field-helpers";
import { getCdcRoleOptions } from "@/i18n/cdc-options";

export type CdcRoleFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<CdcSelectFieldProps<TFieldValues, TName>, "fieldKey" | "options">;

export function CdcRoleField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({ locale, ...rest }: Readonly<CdcRoleFieldProps<TFieldValues, TName>>) {
  return (
    <CdcSelectField
      {...rest}
      fieldKey="role"
      locale={locale}
      options={getCdcRoleOptions(locale)}
    />
  );
}
